// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__29o2H","title":"AfterBackImages_title__Dbf2_","images":"AfterBackImages_images__JY2Zt"};